import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import {
  AppCard,
  AppRemixIcon,
} from '@/layout/AppComponents';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import useIsMounted from '../../../layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import { axiosPath } from "../../../routing/helpers/router";
import * as currentPageAction from '../../../store/actions/currentPageAction';
import EnvironmentalAspectsAssessmentSidebar from '../../../layout/screenSpecifics/Modules/EnvironmentalAspectsAssessment/Sidebar/EnvironmentalAspectsAssessmentSidebar';
import AppSpinner from '../../../layout/components/AppSpinner';
import AppLink from '../../../routing/helpers/AppLink';
import EnvironmentalAspectsAssessmentBase from './EnvironmentalAspectsAssessmentBase';

export default function EnvironmentalAspectsAssessmentInspectionListScreen() {
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData
  );
  const inspections = useSelector((s) => s?.currentPage?.inspections);
  const [loading, setLoading] = useState(true);
  const [breadcrumb, setBreadcrumb] = useState();

  useEffect(() => {
    return () => {
      dispatch(currentPageAction.empty());
    };
  }, []);

  // > LOAD INSPECTIONS
  const loadInspections = async () =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_environmentalAspectsAssessment_inspection_list"
          ),
          {
            moduleBridgeHex,
            plantHex,
          }
        )
        .then(({ data }) => {
          if (isMounted.current) {
            dispatch(currentPageAction.change("inspections", data));
          }
        })
        .catch((e) => dispatch(errorHandler(e)))
        .finally(() => setLoading(false))

  useEffect(() => {
    loadInspections();
  }, []);
  // < LOAD INSPECTIONS

  useEffect(() => {
      if (moduleData) {
        const b = [{ name: moduleData?.moduleName }, { name: 'Fichas de inspecciones' }];

        if (moduleData?.plant) {
          b.unshift({
            name: moduleData?.plant.name,
            route: {
              name: 'user_module_legalCompliance_evaluation',
              params: {
                moduleBridgeHex: moduleData?.plant?.moduleBridgeHex,
                plantHex,
                page: 1,
                filtersHex: 0,
              },
            },
          });
        }

        setBreadcrumb(b);
      } else {
        setBreadcrumb([{ name: '...' }]);
      }
    }, [moduleData]);

  return (
    <>
      <EnvironmentalAspectsAssessmentBase />
      <EnvironmentalAspectsAssessmentSidebar
        activeRoute="user_module_environmentalAspectsAssessment_inspection_list"
        assessmentTitle={moduleData?.assessmentTitle}
      />
      <BreadcrumbHandler paths={breadcrumb} />
      <main role="main" className="col-md-12 col-lg-12 px-md-4 mb-5">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0">
          <AppCard>
            {inspections?.length > 0 ? (
              <>
                <h4 className="mb-4">Fichas de inspecciones</h4>
                <div className="table-responsive">
                  <table className="table table-hover table-sm">
                    <thead>
                      <tr>
                        <th className="col-12">Nombre</th>
                      </tr>
                    </thead>
                    <tbody>
                      {inspections.map((a) => (
                        <tr key={a.hex}>
                          <td>
                            <AppLink
                              path="user_module_environmentalAspectsAssessment_inspection_home"
                              params={{
                                moduleBridgeHex,
                                plantHex,
                                assessmentHex: a.hex,
                              }}
                            >
                              {a.title}
                            </AppLink>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : loading ? (
              <AppSpinner>
                <AppRemixIcon icon="loader-4" size={40} />
              </AppSpinner>
            ) : (
              <div className="alert alert-info">
                No se ha encontrado ninguna inspección
              </div>
            )}
          </AppCard>
        </div>
      </main>
    </>
  );
}
